import { render, staticRenderFns } from "./v-datatable.vue?vue&type=template&id=c670bbaa&scoped=true&"
import script from "./v-datatable.vue?vue&type=script&lang=js&"
export * from "./v-datatable.vue?vue&type=script&lang=js&"
import style0 from "./v-datatable.vue?vue&type=style&index=0&id=c670bbaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c670bbaa",
  null
  
)

export default component.exports